/**
 * Supabase project coordinates for the sync layer.
 *
 * The anon key is the PUBLISHABLE key: it is designed to ship in client
 * bundles and grants nothing by itself — every table in the sketch schema is
 * behind RLS, and this key only lets a client attempt requests that those
 * policies then allow or deny per-user. The security boundary is the
 * policies (docs/DATABASE.md, ADR 0006), never this constant.
 *
 * Kept in its own module so nothing else needs to know project coordinates,
 * and so a future preview-environment build can swap this file alone.
 */
export const SUPABASE_URL = 'https://hmcwjyxbmdxhpxidfmxf.supabase.co';
export const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhtY3dqeXhibWR4aHB4aWRmbXhmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQ2NjY3OTUsImV4cCI6MjEwMDI0Mjc5NX0.1uKexnxx6lk9fNNPMV57KXovih-Wggp-Ciqf0PXHJXs';